<template>
  <v-app>
    <v-container fluid fill-height class="darkbg">
      <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="6"
            md="4"
            align="center"
          >
            <img :src="images.logo" width="150"/>
            <v-card
              class="elevation-12"
              light
            >
              <v-card-title class="pb-0">
                Activate account
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout
                  row
                  fill-height
                  justify-center
                  align-center
                  v-if="loading"
                >
                  <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                  />
                </v-layout>
                Activation in progress
              </v-card-text>
            </v-card>
            <v-btn class="text-left" text to="/portal/home"><v-icon left dark>mdi-arrow-left</v-icon>Back to Home</v-btn>
          </v-col>
      </v-row>
      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}
        <v-btn text @click="snack = false">Close</v-btn>
      </v-snackbar>
    </v-container>
    <v-footer>
     <v-spacer></v-spacer>
    <div class="caption">&copy; {{ new Date().getFullYear() }} - Patrowl.io</div>
   </v-footer>

  </v-app>
</template>

<script>
export default {
  name: 'AppSignupActivation',
  data: () => ({
    loading: false,
    uid: '',
    token: '',
    images: {
      // logo: require('@/assets/img/logo-owl-text-large-white.png'),
      logo: require('@/assets/img/logo-patrowl-black.png'),
    },
    snack: false,
    snackColor: '',
    snackText: '',
  }),
  beforeRouteUpdate(to) {
    this.uid = to.query.uid;
    this.token = to.query.token;
    this.checkToken();
  },
  mounted() {
    this.uid = this.$router.currentRoute.query.uid;
    this.token = this.$router.currentRoute.query.token;
    this.checkToken();
  },
  methods: {
    checkToken() {
      this.$api.get('/api/public/users/activate/'+this.uid+"/"+this.token).then(res => {
        if (res && res.status === 200 && res.data.status === "ok") {
          // this.registration.email = res.data.email;
          this.snack = true;
          this.snackColor = 'success';
          this.snackText = 'User account successfuly activated.';
          // this.$router.push('/login');
          setTimeout( () => this.$router.push('/login'), 3000);

        } else {
          // this.$router.push('/portal/home');
          this.snack = true;
          this.snackColor = 'error';
          this.snackText = res.data.message;
        }
      }).catch(e => {
        console.log(e);
        this.snack = true;
        this.snackColor = 'error';
        this.snackText = "Unable to activate this account. Link already used ?";
        // this.$router.push('/portal/home');
        setTimeout( () => this.$router.push('/portal/login'), 5000);
      });

    },
  },
}
</script>
<style scoped>

</style>
